/* eslint-disable */

function setCookie(name, value, days) {
    var date = new Date();
    var domain = getDomainWithoutSubdomain();
    date.setTime(date.getTime() + (24 * 60 * 60 * 1000 * days));
    document.cookie = name + '=' + value + ';domain=' + domain + ';path=/;expires=' + date.toGMTString();
}

function getCookie(name) {
    var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? v[2] : null;
}

function deleteCookie(name) {
    setCookie(name, '', -1);
}

function removeCookiesByName(cookies) {
    for (var c = 0; c < cookies.length; c++) {
        set_cookie(cookies[c], "")
        delete_cookie(cookies[c]);
    }

}

function set_cookie(name, value) {
    document.cookie = name + '=' + value + '; Path=/;';
    console.log("set cookie" + name + value)
}

function delete_cookie(name) {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    console.log("delete cookie" + name)

}

function deleteCookies(cookies) {
    for (var c = 0; c < cookies.length; c++) {
        var d = window.location.hostname.split('.');
        var prefixDot = '';
        while (d.length > 0) {
            if (d.length === 2) {
                prefixDot = '.';
            }
            var cookieBase = cookies[c] + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=' + prefixDot + d.join('.') + ' ;path=';
            var p = location.pathname.split('/');
            document.cookie = cookieBase + '/';
            while (p.length > 0) {
                document.cookie = cookieBase + p.join('/');
                p.pop();
            }
            d.shift();
        }
    }
}

function getDomainWithoutSubdomain() {
    var parts = window.location.hostname.split('.');
    return parts.slice(0).slice(-(parts.length === 4 ? 3 : 2)).join('.');
}
